import { render, staticRenderFns } from "./LvAssignmentSwiper.vue?vue&type=template&id=198b0214"
import script from "./LvAssignmentSwiper.vue?vue&type=script&lang=js"
export * from "./LvAssignmentSwiper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports